import React, { useEffect, useState } from "react";
import { getApplicationMode } from "../services/publicApi";

const TestModeBadge = () => {
  const [isTestMode, setIsTestMode] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadMode = async () => {
      try {
        const modeRes = await getApplicationMode();
        const data = modeRes?.data;
        if (!cancelled) {
          setIsTestMode(data?.mode === "TEST" || data?.testMode === true);
        }
      } catch {
        if (!cancelled) {
          setIsTestMode(false);
        }
      }
    };

    loadMode();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!isTestMode) {
    return null;
  }

  return (
    <div className="test-mode-badge" aria-label="Test Mode">
      Test Mode
    </div>
  );
};

export default TestModeBadge;
